import { BaseObjectModelEntryValidator } from "./baseObjectModelEntryValidator";
import { ObjectModelEntryPropertyValidator } from "./objectModelEntryPropertyValidator";
import ObjectModelEntry from "../objectModelEntry";
import ValidationError from "../../validationError";
import { RegexHelper } from "~/helpers/regexHelper";
import {ObjectModelRelationType} from "~/enums/objectModelRelationType";

export default class ObjectModelEntryValidator extends BaseObjectModelEntryValidator {
  constructor(entry: ObjectModelEntry) {
    super(entry);

    this.validators = entry.published_object_model.objectModelPropertiesArray.reduce<BaseObjectModelEntryValidator[] | any>((arr, prop) => {
      const validators = ObjectModelEntryPropertyValidator.validatorsFor(entry, prop);
      return [...arr, ...validators];
    }, this.validators);

    // setup
    const requiredValidator = (relation) => ({
      errors: [],
      validate: function () {
        this.errors = []
        if (relation.entry_relations.filter(rjo => rjo.entry_id === entry.id).length === 0) {
          this.errors.push(new ValidationError({ field: relation.client_id, message: "Please relate a record."}))
        }
      }
    })

    const accountRelationshipEmailValidator = relation => ({
      errors:[],
      validate: function() {
        this.errors = [];
        const bothFieldsBlank = relation.new_email === "" && relation.new_email_confirmation === "";
        const emailProperlyFormatted = relation.new_email !== "" && RegexHelper.emailOrBlank.test(relation.new_email);
        const emailsMatch = relation.new_email !== "" && relation.new_email.toLowerCase() === relation.new_email_confirmation.toLowerCase();
        const invalidEmail = !emailProperlyFormatted || !emailsMatch;
        if (!bothFieldsBlank && invalidEmail) {
          const error = new ValidationError({
            field: relation.client_id,
            message: "Does not meet criteria",
          });
          this.errors.push(error);
        }
      }
    })

    // apply
    this.entry.relations.forEach(relation => {
      if (relation.is_required) {
        this.validators.push(requiredValidator(relation))
      }
      const isAccountRelation = relation.isAccountRelationship;
      if (isAccountRelation && !relation.isFormabilityUserType) {
        this.validators.push(accountRelationshipEmailValidator(relation));
      }
    })
  }

  protected _validate(): ValidationError | null {
    // only run validation when first creating an entry
    // section only displays when entry is not persisted
    if (!this.entry.id) {
      if (this.entry.has_owner) {
        const email = this.entry.owner_email;
        if (!email || !RegexHelper.emailOrBlank.test(email)) {
          return new ValidationError({ message: 'Please enter a valid email', field: 'owner_email' });
        }
      }
    }
  }
}
